import { observer } from 'mobx-react'
import './index.scss'
import { ReactComponent as Close } from '../../../../assets/track/close.svg'
import { useState } from 'react'
import classNames from 'classnames'
import { changePass } from '../../../../stores/UserModel'
import ContentState from '../../../../stores/ContentState'

const RestartPassword = observer(({ setStep }: { setStep: () => void }) => {
  const [showPop, setShowPop] = useState(false)
  const [state, setState] = useState({
    email: '',
    error: '',
  })
  const emailValidate = (email: string) => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
  }

  const submit = () => {
    const err = !state.email.length
      ? content.emptyFillError
      : state.email.length && emailValidate(state.email)
      ? ''
      : content.incorrectEmail

    if (err.length) {
      setState({ ...state, error: err })
      return
    }

    changePass(state.email).then(() => {
      setShowPop(true)
    })
  }

  if (!ContentState.forgot) return <></>
  const content = ContentState.forgot
  return (
    <section className="restart-pass">
      {!showPop ? (
        <div className="login-content2__content">
          <div className="login-content2__close" onClick={setStep}>
            <Close />
          </div>
          <div className="login-content2__title">{content.title}</div>
          <div
            className="login-content2__slim-text"
            dangerouslySetInnerHTML={{ __html: content.text }}
          ></div>
          <div
            className={classNames(
              'login-content2__input',
              state.error.length && 'error',
              state.email && 'fill',
            )}
          >
            <input
              placeholder="Email *"
              className="input"
              type="email"
              onChange={(e) => setState({ ...state, email: e.target.value })}
              value={state.email}
            />
          </div>
          {state.error.length ? (
            <div className="login-content2__error">{state.error}</div>
          ) : (
            <></>
          )}
          <div className="button black" onClick={submit}>
            {content.sendBut}
          </div>
          <div className="button grey-border" onClick={setStep}>
            {content.rememberText}
          </div>
        </div>
      ) : (
        <div className="login-content2__content pop">
          <div className="login-content2__title">{content.sendEmail.title}</div>
          <div className="login-content2__slim-text">
            {content.sendEmail.text}
            <span>{state.email}</span>
          </div>
          <div className="button black" onClick={setStep}>
            {content.sendEmail.butText}
          </div>
        </div>
      )}
    </section>
  )
})

export default RestartPassword
